var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraitIconsMotivation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(.667)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.272,
    cy: 15.386,
    r: 14.953,
    fill: "#B1B1B1",
    opacity: 0.2,
    transform: "translate(0 .667)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425CC7",
    d: "M20.36 5.9L16.969 5.9 16.969 29.761 13.986 29.761 13.986 5.9 10.596 5.9 15.478 1.374z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002554",
    d: "M16.97 30.16h-4.511c-.221 0-.4-.18-.4-.4V6.3H9.067c-.165 0-.313-.101-.373-.254-.06-.154-.02-.328.1-.44L14.442.373c.153-.142.39-.142.544 0l5.646 5.233c.12.112.16.286.1.44-.06.153-.207.253-.372.253h-2.99v23.462c-.001.22-.18.399-.4.399zm-4.111-.8h3.71V5.9c0-.22.18-.4.4-.4h2.371l-4.626-4.288L10.089 5.5h2.37c.22 0 .4.18.4.4v23.46zM27.164 31.237c-.22 0-.4-.18-.4-.4v-18.97c0-.221.18-.4.4-.4h1.333L25.6 8.786l-2.895 2.68h1.334c.22 0 .4.18.4.4v17.445c0 .22-.18.4-.4.4-.221 0-.4-.18-.4-.4V12.267h-1.954c-.165 0-.313-.101-.373-.254s-.02-.328.1-.44l3.916-3.628c.154-.143.391-.143.545 0l3.915 3.628c.12.112.16.287.1.44-.06.153-.208.254-.373.254h-1.951v18.57c0 .221-.18.4-.4.4zM2.923 29.584c-.22 0-.4-.18-.4-.4V15.28H1.151c-.164 0-.312-.1-.373-.254-.06-.153-.02-.327.1-.44l2.951-2.733c.154-.142.391-.142.545 0l2.95 2.734c.12.112.16.286.1.44-.06.152-.208.253-.373.253H5.68v12.886c0 .22-.18.4-.4.4-.22 0-.4-.18-.4-.4V14.88c0-.22.18-.4.4-.4h.751l-1.933-1.79-1.933 1.79h.758c.106 0 .208.042.283.117.075.075.117.177.117.283v14.304c0 .22-.179.4-.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425CC7",
    d: "M9.517 27.317c-.221 0-.4-.179-.4-.4v-4.925c0-.22.179-.4.4-.4.22 0 .4.18.4.4v4.925c0 .221-.18.4-.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002554",
    d: "M9.517 20.37c-.221 0-.4-.18-.4-.4v-2.574c0-.22.179-.4.4-.4.22 0 .4.18.4.4v2.574c0 .22-.18.4-.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425CC7",
    d: "M19.829 31.733c-.221 0-.4-.179-.4-.4v-4.925c0-.22.179-.4.4-.4.22 0 .4.18.4.4v4.925c0 .221-.18.4-.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002554",
    d: "M19.829 24.786c-.221 0-.4-.18-.4-.4v-2.574c0-.22.179-.4.4-.4.22 0 .4.18.4.4v2.574c0 .22-.18.4-.4.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraitIconsMotivation);
export default __webpack_public_path__ + "static/media/trait-icons-motivation.7f3dff72bf5a8fe6f23976bc8ab084df.svg";
export { ForwardRef as ReactComponent };